<mat-drawer-container class="container" autosize>
  <mat-drawer #drawer [opened]="opened$ | async">
    
    <section>
      
      <div id="camToggle">
        <mat-slide-toggle [checked]="isChecked" (change)="toggleChanges($event)"> Camera {{videoOnOff}}</mat-slide-toggle>
      </div>

      <a [class.focus]="(selection$ | async) === 'home'" #home routerLink="home"
        ><mat-icon>home</mat-icon></a
      >
      
      <a
        [class.focus]="(selection$ | async) === 'about'"
        #about
        routerLink="about"
        ><mat-icon>info</mat-icon></a
      >

      <a
        [class.focus]="(selection$ | async) === 'img'"
        #img
        routerLink="img"
        ><mat-icon>perm_media</mat-icon></a
      >

      <a
        [class.focus]="(selection$ | async) === 'vid'"
        #vid
        routerLink="vid"
        ><mat-icon>camera_front</mat-icon></a
      >

       <a
        [class.focus]="(selection$ | async) === 'mnist'"
        #mnist
        routerLink="mnist"
        ><mat-icon>create</mat-icon></a
      >

      <a
        [class.focus]="(selection$ | async) === 'face'"
        #face
        routerLink="face"
        ><mat-icon>face</mat-icon></a
      >
    </section>
  </mat-drawer>

  <div class="sidenav-content">
    <router-outlet></router-outlet>
  </div>
</mat-drawer-container>

<button
  class="hamburger hamburger--slider"
  [class.is-active]="drawer.opened"
  type="button"
  (click)="drawer.toggle()"
>
  <span class="hamburger-box">
    <span class="hamburger-inner"></span>
  </span>
</button>


<div *ngIf="isChecked === true">
  <video
    style="display: none"
    #video
    width="640"
    height="480"
    autoplay
    [srcObject]="stream"
  ></video>
<canvas #canvas width="640" height="480"></canvas>
</div>

